import React from 'react';
import './RightPanel.css';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteIcon from '@material-ui/icons/Delete';

const EditCart = (props) => {
  const cart = props.cart
  const lineItems = props.cartItems;

  const updateCart = (newItem, type) => {
    const itemIndex = cart.line_items.indexOf(cart.line_items.find((item) => newItem.product_id === item.product_id));
    props.updateCart(newItem, type, itemIndex);
  }

  return (
    <table>
      {lineItems?.map(item => {
        return (
          <tr className="editTableRow">
            <td className="editTable editTableImg"><img src={item.image} className="editCartImg" /></td>
            <div className="editCartTableSection">
              <td className="editTable editTableName">{item.title}</td>
              <div className="editCartButtons">
                <td className="editTable editTableBtn"><button onClick={() => updateCart(item, "remove")}><RemoveIcon style={{ fontSize: 10 }} /></button></td>
                <td className="editTable editTableQty">{item.quantity}</td>
                <td className="editTable editTableBtn"><button onClick={() => updateCart(item, "add")}><AddIcon style={{ fontSize: 10 }} /></button></td>
                <td className="editTable editTableBtn"><DeleteIcon onClick={() => updateCart(item, "delete")} style={{ fontSize: 12 }} /></td>
              </div>
            </div>
          </tr>
        )
      })}
    </table>
  )
}

export default EditCart;